export default "__VITE_ASSET__PBjLqj3H__"